import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { PermissionService } from '../services/permission.service';

/**
 * Guard that checks if user has required roles
 * Usage: canActivate: [roleGuard(['ADMIN', 'HR_MANAGER'])]
 */
export function roleGuard(requiredRoles: string[]): CanActivateFn {
  return () => {
    const permissionService = inject(PermissionService);
    const router = inject(Router);

    return permissionService.hasAnyRole(requiredRoles).pipe(
      take(1),
      map(hasRole => {
        if (!hasRole) {
          router.navigate(['/access-denied']);
          return false;
        }
        return true;
      })
    );
  };
}


